// extracted by mini-css-extract-plugin
module.exports = {"container":"Projects_container__24SQw","title":"Projects_title__3BfIb","list":"Projects_list__-mEBj","link":"Projects_link__14vvA"};